<template>
  <div class="download-root" :style="{ ...background }">
    <Computer
      v-if="isComputer"
      :uri="uri"
      @switch-to-mobile="handleSwitchToMobile"
    />
    <Mobile v-else :uri="uri" :isWeiXin="isWeiXin" />
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import {
  isComputer as checkIsComputer,
  isWeiXin as checkIsWeiXin,
} from "@/Utils/UtilTools";
import Computer from "./Download/Computer.vue";
import Mobile from "./Download/Mobile.vue";

const { appContext } = getCurrentInstance();
const bus = appContext.config.globalProperties.bus;

const route = useRoute();

const uri = ref("");
const isComputer = ref(true);
watch(
  () => route.params?.uri,
  (val) => {
    if (route.name !== "Download") {
      // 离开页面
      bus.emit("change-topnav-state", true); // 还原
      return;
    }

    uri.value = val;
  },
  { immediate: true }
);
onMounted(() => {
  isComputer.value = checkIsComputer();
  bus.emit("change-topnav-state", isComputer.value);
  uri.value = route.params?.uri;
});

const isWeiXin = ref(false);
const background = ref({ backgroundColor: "#1f86e4", backgroundImage: "none" });
watch(isComputer, (val) => {
  if (val) {
    background.value = { backgroundColor: "#1f86e4", backgroundImage: "none" };
  } else {
    isWeiXin.value = checkIsWeiXin();
    if (isWeiXin.value) {
      background.value = {
        backgroundColor: "none",
        backgroundImage: "url(/assets/images/mobilebjweixin.png)",
      };
    } else {
      background.value = {
        backgroundColor: "none",
        backgroundImage: "url(/assets/images/mobilebj.png)",
      };
    }
  }
});

function handleSwitchToMobile() {
  // 适配移动端
  isComputer.value = false;
  bus.emit("change-topnav-state", isComputer.value);
}
</script>

<style lang="scss" scoped>
.download-root {
  height: 100%;
  width: 100%;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100%;
}
</style>
